<template>
  <form-label-group :label="calcLabel" class="mb-2">
    <b-form-input
      v-model="innerValue"
      :placeholder="calcLabel"
      :size="size || 'lg'"
      :formatter="getFormattedNumber"
      type="tel"
      class="phone-number-input"
      @blur="onBlur"
      @focus="onFocus"
    />
  </form-label-group>
</template>

<script>
import FormLabelGroup from '@/components/organisation/FormLabelGroup';
import { AsYouType } from 'libphonenumber-js';

const asYouType = new AsYouType('SE');

export default {
  name: 'PhoneNumberFieldLegacy',

  components: { FormLabelGroup },

  props: ['size', 'placeholder', 'label', 'required', 'value'],

  data() {
    return {
      innerValue: null,
    };
  },

  methods: {
    getFormattedNumber(phoneNumber) {
      let phoneNumberString = String(phoneNumber).trimStart();

      if (phoneNumberString.charAt(0) !== '+') {
        phoneNumberString = `+${phoneNumberString}`;
      }

      asYouType.reset();

      return asYouType.input(phoneNumberString);
    },

    onBlur() {
      if (this.innerValue === '+') {
        this.innerValue = '';
      }
      this.$emit('input', this.innerValue);
    },

    onFocus() {
      if (!this.innerValue) {
        this.innerValue = '+';
      }
    },
  },

  computed: {
    calcLabel() {
      return this.required ? this.label + ' *' : this.label;
    },
  },

  watch: {
    value: {
      immediate: true,
      handler(next) {
        this.innerValue = next;
      },
    },
  },
};
</script>

<style scoped>
.phone-number-input {
  font-size: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/form/PhoneNumberFieldLegacy.vue